// Formatage des numéros de téléphone à la française.
// Normalise (0033/33/+33 → national), affiche "06 12 34 56 78" ; garde le code pays si étranger.
function nationalDigits(raw) {
  let d = String(raw || "").replace(/[^\d+]/g, "");
  if (d.startsWith("0033")) d = "+33" + d.slice(4);
  if (d.startsWith("+33")) return d.slice(3).replace(/\D/g, "");
  if (d.startsWith("33") && d.replace(/\D/g, "").length === 11) return d.replace(/\D/g, "").slice(2);
  return d.replace(/\D/g, "");
}

export function formatPhoneFR(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  // Numéro étranger explicite (autre que +33) : on garde le +XX et on groupe par 2.
  if (/^\+(?!33)/.test(s.replace(/[^\d+]/g, ""))) {
    const cc = s.replace(/[^\d+]/g, "");
    return cc.replace(/(\+\d{2})(\d+)/, (m, c, rest) => c + " " + rest.replace(/(\d{2})(?=\d)/g, "$1 ").trim());
  }
  let d = nationalDigits(s);
  if (d.length === 9 && !d.startsWith("0")) d = "0" + d; // ex. "612345678"
  if (d.length === 10) return d.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
  return s; // format inconnu : on renvoie tel quel
}

// Valeur normalisée pour stockage : national FR sans espaces (0XXXXXXXXX) par défaut, +XX pour l'étranger.
export function normalizePhone(raw) {
  if (!raw) return "";
  let d = String(raw).replace(/[^\d+]/g, "");
  if (d.startsWith("+") && !d.startsWith("+33") && !d.startsWith("+0")) return "+" + d.slice(1).replace(/\D/g, "");
  const nat = nationalDigits(d);
  if (nat.length === 10) return nat;
  if (nat.length === 9) return "0" + nat;
  return d;
}
